<div style="position: relative;widows: 100%;;height: 100%;">
    <canvas #chartCanvas  ></canvas>
</div>